export const getDefaultDateRange = (onlyDate, onlyToday) => {
  const today = new Date();
  const tomorrow = new Date(today);
  tomorrow.setDate(today.getDate() + 1);

  const formatDateForInput = (date) => {
    return date.toISOString().split("T")[0];
  };

  return {
    startDate: onlyDate ? formatDateForInput(today) : today,
    endDate: onlyDate && onlyToday ? formatDateForInput(today) : tomorrow,
  };
};
